import { GridApi } from "ag-grid-enterprise";
import { FeatureTypes } from "entity-app/constants";
import { getFeatureEntityLog } from "services/feature-apis";

type TMaterialCommentsResponse = Array<{ id: string; comments?: string[] }>;

/** Material id -> comments for exports; null when the request fails. */
export const fetchCommentsByMaterialId = async (projectToken: string) => {
  const res = await getFeatureEntityLog({
    projectToken,
    featureType: FeatureTypes.MATERIALS,
    include_comments: true
  });
  if (!res.success || !Array.isArray(res.data)) return null;
  return new Map<string, string[]>(
    (res.data as TMaterialCommentsResponse).map((row) => [
      row.id,
      row.comments ?? []
    ])
  );
};

/**
 * AG Grid reads cell values after its "Exporting" overlay renders, not inside
 * exportDataAsCsv/Excel, so comments must stay on the rows past the export
 * call. The column is hidden and only exported when comments are requested,
 * and every such export refreshes them.
 */
export const attachCommentsToRows = (
  api: GridApi<{ id: string; comments?: string[] }>,
  commentsById: Map<string, string[]>
) => {
  api.forEachNode((node) => {
    if (!node.data) return;
    node.data.comments = commentsById.get(node.data.id) ?? [];
  });
};
